import { createHash } from "crypto";

export enum VARIANTS {
  ADMIN = "admin",
  SUPPORT = "support",
  MERCHANT = "merchant",
}

export enum COLORS {
  ADMIN = "blue",
  SUPPORT = "green",
  MERCHANT = "primary",
}

export const getColor = (variant?: string): string => {
  switch (variant) {
    case VARIANTS.ADMIN:
      return COLORS.ADMIN;
    case VARIANTS.SUPPORT:
      return COLORS.SUPPORT;
    case VARIANTS.MERCHANT:
    default:
      return COLORS.MERCHANT;
  }
};

export const classNames = (...classes: string[]) => {
  return classes.filter(Boolean).join(" ");
};

export async function convertToHash(message: string) {
  return createHash("sha256").update(message).digest("hex");
}

export const validatePassword = (pass: string) => {
  return pass.length >= 5 && /\d/.test(pass) && !/\s/.test(pass);
};

export function validateEmail(email: string): boolean {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

function url_base64_decode(str: string) {
  let output = str.replace(/-/g, "+").replace(/_/g, "/");
  switch (output.length % 4) {
    case 0:
      break;
    case 2:
      output += "==";
      break;
    case 3:
      output += "=";
      break;
    default:
      // eslint-disable-next-line no-throw-literal
      throw "Illegal base64url string!";
  }
  let result = window.atob(output);
  try {
    return decodeURIComponent(escape(result));
  } catch (err) {
    return result;
  }
}

export const getParsedToken = (token: string) => {
  const base64Url = token.split(".")[1];
  const base64 = url_base64_decode(base64Url);
  return JSON.parse(base64);
};

export const convertDateToObject = (
  dateString: string | number,
): {
  fullYear: string;
  month: string;
  day: string;
  hour: string;
  minute: string;
  second: string;
  stringDDMMYYYY: string;
  stringHHMM: string;
  timeZoneOffsetString: string;
  timeZoneOffsetHour: number;
} => {
  const date = new Date(dateString);
  const timeZoneOffset = date.getTimezoneOffset();
  const offsetHour = Math.abs(timeZoneOffset / 60).toFixed();
  const offsetMinutes =
    timeZoneOffset % 60 === 0
      ? "00"
      : timeZoneOffset % 60 > 10
        ? "0" + (timeZoneOffset % 60)
        : timeZoneOffset % 60;

  const dateObject = {
    fullYear: date.getFullYear().toString(),
    month:
      date.getMonth() + 1 > 9
        ? (date.getMonth() + 1).toString()
        : `0${date.getMonth() + 1}`,
    day: date.getDate() > 9 ? date.getDate().toString() : `0${date.getDate()}`,
    hour:
      date.getHours() > 9 ? date.getHours().toString() : `0${date.getHours()}`,
    minute:
      date.getMinutes() > 9
        ? date.getMinutes().toString()
        : `0${date.getMinutes()}`,
    second:
      date.getSeconds() > 9
        ? date.getSeconds().toString()
        : `0${date.getSeconds()}`,
    stringDDMMYYYY: "",
    stringHHMM: "",
    timeZoneOffsetString: `${timeZoneOffset > 0 ? "-" : "+"}${+offsetHour >= 600 ? offsetHour : "0" + offsetHour}:${offsetMinutes}`,
    timeZoneOffsetHour:
      timeZoneOffset > 0 ? -Number(offsetHour) : Number(offsetHour),
  };
  dateObject.stringDDMMYYYY = `${dateObject.day}.${dateObject.month}.${dateObject.fullYear}`;
  dateObject.stringHHMM = `${dateObject.hour}:${dateObject.minute}`;

  return dateObject;
};
